import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './App';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-484758-1',
  // checkDuplicatedScript: true
  disableScriptLoader: true,
  autoTracking: {
    exception: true,
  },
  debug: {
    enabled: false,
    sendHitTask: true,
  },
});

Vue.mixin({
  methods: {
    formatPrice(value) {
      const val = (value / 1).toFixed(2); // .replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js